exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bs-doc-upload-container{border:1px solid #acacac;margin:10px;padding:10px;border-radius:5px;background:#fff}.bs-doc-upload-container .text-danger{font-size:14px;padding:2px;text-align:center}\n", ""]);

